<template>
  <v-dialog v-model="dashboardInfoDialog" width="800">
    <v-card>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <span class="display-1 text-uppercase font-weight-bold">{{$t('infoDialogs.private.dashboard.Title')}}</span>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('infoDialogs.private.dashboard.general.Close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="pr-5 text--primary title">{{$t('infoDialogs.private.dashboard.PageDescription')}}.</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-row>
          <v-col md="4">
            <span class="body-1 text--primary font-weight-bold">Text to come</span>
          </v-col>
          <v-col md="8">
            <span class="body-1 text--primary">{{$t("test")}}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Import the i18n - This may need to be modified
import messages from "../../modules/lang/export";
export default {
  // Communicate with i18n
  i18n: { messages },
  data(){
    return{
      // Define the dialog v-model that we are using
      dashboardInfoDialog:false,
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
      this.dashboardInfoDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.dashboardInfoDialog = false;
    }
  }
}
</script>